module.exports = __webpack_public_path__ + "14-winter-snow.50aee89b38ec4d4f4e73.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/festival/14-winter-snow.png
// module id = ../../../../../src/assets/images/festival/14-winter-snow.png
// module chunks = styles